var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pagebox" },
    [
      _c("div", { staticClass: "banneranav" }, [
        _c(
          "div",
          { staticClass: "wx-box" },
          [
            _c(
              "mt-swipe",
              {
                staticClass: "wx-banner",
                attrs: { auto: 4000, "show-indicators": false }
              },
              _vm._l(_vm.bannerList, function(item, index) {
                return _c("mt-swipe-item", { key: item.index }, [
                  _c("img", { attrs: { src: item.coverurl } })
                ])
              })
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "nav-box" },
          _vm._l(_vm.navlist, function(item, index) {
            return _c(
              "div",
              {
                key: item.index,
                staticClass: "wx-chid",
                on: {
                  click: function($event) {
                    _vm.goallclass(index, item.coursetype)
                  }
                }
              },
              [
                _c("img", { attrs: { src: item.navpic } }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(item.anvname))])
              ]
            )
          })
        )
      ]),
      _vm._v(" "),
      !_vm.logined
        ? _c("div", { staticClass: "loginbox" }, [
            _c("div", { staticClass: "login-bg" }, [
              _vm._v("\n            您还没有  "),
              _c(
                "span",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      _vm.goToLogin()
                    }
                  }
                },
                [_vm._v("登录")]
              ),
              _vm._v("  喔，选择心仪的课程报名学习吧~\n        ")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.logined
        ? _c("div", { staticClass: "loginafter" }, [
            _c("div", { staticClass: "class-top" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "right-navs" }, [
                _c(
                  "a",
                  {
                    attrs: { href: "javascript:void(0)" },
                    on: {
                      click: function($event) {
                        _vm.courseListInfo()
                      }
                    }
                  },
                  [_vm._m(1)]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "wc-child wc-child2" }, [
              _c("div", { staticClass: "wc-poster wc-poster2" }, [
                _c("img", { attrs: { src: _vm.continueCourse.coverpath } })
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "wx-right wx-right2",
                  on: {
                    click: function($event) {
                      _vm.routerToDetail(_vm.continueCourse.courseId)
                    }
                  }
                },
                [
                  _c("ul", { staticClass: "containue" }, [
                    _c("li", { staticClass: "containue-title" }, [
                      _vm._v(_vm._s(_vm.continueCourse.title))
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "containue-study" }, [
                      _vm._v(_vm._s(_vm.continueCourse.progressDesc))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "containue-time" }, [
                    _vm._v(
                      "当前课程剩余 " + _vm._s(_vm.continueCourse.nextLength)
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "progresss" }, [
                    _vm._v("当前进度："),
                    _c("span", { staticClass: "jd" }, [
                      _vm._v(_vm._s(_vm.continueCourse.record) + "/100")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("mt-progress", {
                    attrs: { value: _vm.continueCourse.record, "bar-height": 5 }
                  }),
                  _vm._v(" "),
                  _c("ul", { staticClass: "containue-learn" }, [
                    _c("li", { staticClass: "containue-stu" }, [
                      _vm._v(_vm._s(_vm.continueCourse.progressDesc))
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "containue-times" }, [
                      _vm._v(
                        "共计" +
                          _vm._s(_vm.continueCourse.lessonCount) +
                          "课时 | " +
                          _vm._s(_vm.continueCourse.lessonDuration)
                      )
                    ])
                  ])
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "class-typx" }, [
        _c("div", { staticClass: "class-top" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "right-nav" }, [
            _c(
              "ul",
              { staticClass: "nav-scroll" },
              _vm._l(_vm.classlist, function(item, index) {
                return _c(
                  "li",
                  {
                    key: item.index,
                    class: { active: _vm.cur == index },
                    on: {
                      click: function($event) {
                        _vm.getclass(index, item.coursetype)
                      }
                    }
                  },
                  [_vm._v(_vm._s(item.classname))]
                )
              })
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "wx-child-box" },
          _vm._l(_vm.classconlist, function(item, index) {
            return _c(
              "div",
              {
                key: item.index,
                staticClass: "wc-child",
                on: {
                  click: function($event) {
                    _vm.gonext(item.courseid)
                  }
                }
              },
              [
                _c("div", { staticClass: "wc-poster" }, [
                  _c("img", { attrs: { src: item.conpic } })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "wx-right" }, [
                  _c("ul", { staticClass: "wx-title-time" }, [
                    _c("li", { staticClass: "wx-tchild" }, [
                      _c("span", { staticClass: "tc-title" }, [
                        _vm._v(_vm._s(item.contitle))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "tc-time" }, [
                        _vm._v(
                          "共" +
                            _vm._s(item.classnum) +
                            "课时 | " +
                            _vm._s(item.classtime)
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "tc-price" }, [
                      _vm._v(_vm._s(item.price))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "user-box" }, [
                    _c("li", { staticClass: "user" }, [
                      _c("span", { staticClass: "user-img" }, [
                        _c("img", { attrs: { src: item.userpic } })
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "username" }, [
                        _vm._v(_vm._s(item.username))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "userstudy" }, [
                      _vm._v(_vm._s(item.usernum) + "人学习")
                    ])
                  ])
                ])
              ]
            )
          })
        )
      ]),
      _vm._v(" "),
      _c("footer-nav")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "classbox" }, [
      _c("li", { staticClass: "book" }, [
        _c("img", { attrs: { src: require("../../assets/images/record.png") } })
      ]),
      _vm._v(" "),
      _c("li", [_vm._v("正在学习")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "more" }, [
      _vm._v("更多  "),
      _c("img", {
        attrs: { src: require("../../assets/images/right-icon.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "classbox" }, [
      _c("li", { staticClass: "book" }, [
        _c("img", { attrs: { src: require("../../assets/images/book.png") } })
      ]),
      _vm._v(" "),
      _c("li", [_vm._v("课程分类")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-711376f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-711376f6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/index/lzindex.vue
// module id = null
// module chunks = 